/**
 * @generated SignedSource<<7eb8caa9e2d1e2196c5cdec4fd72e277>>
 * @relayHash f06abf01dc4b25e556cc9c4f8841e1d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c6e609b4c182572eead8c06b423fcc978804165e978a3d9b667418888cd7cd9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WidgetConfigurationNavEntryPointQuery } from './WidgetConfigurationNavEntryPointQuery.graphql';

const node: PreloadableConcreteRequest<WidgetConfigurationNavEntryPointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6c6e609b4c182572eead8c06b423fcc978804165e978a3d9b667418888cd7cd9",
    "metadata": {},
    "name": "WidgetConfigurationNavEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
